var map = {
	"./AlertIcon": 5097,
	"./BankIcon": 87428,
	"./BookIcon": 87170,
	"./BriefcaseIcon": 18460,
	"./BudgetIcon": 15596,
	"./BuildIcon": 13991,
	"./BuildingIcon": 30453,
	"./BulbIcon": 7548,
	"./CarIcon": 38473,
	"./CardIcon": 90933,
	"./CartIcon": 56561,
	"./CategoryIcon": 80788,
	"./ClientIcon": 61342,
	"./ClockIcon": 94047,
	"./CoffeeIcon": 22822,
	"./CoinIcon": 55537,
	"./EducationIcon": 53653,
	"./GamesIcon": 64093,
	"./GiftcardIcon": 3991,
	"./InventoryIcon": 85874,
	"./InvoiceIcon": 43473,
	"./LockIcon": 93829,
	"./MealsIcon": 96631,
	"./MedicalIcon": 86845,
	"./MoneyIcon": 42714,
	"./MonitorIcon": 16550,
	"./PaletteIcon": 38411,
	"./PlaneIcon": 22419,
	"./SavingsIcon": 71677,
	"./SettingsIcon": 35143,
	"./TrendingupIcon": 79220,
	"./WalletIcon": 8392,
	"./WithdrawIcon": 72913
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	if(!__webpack_require__.m[id]) {
		var e = new Error("Module '" + req + "' ('" + id + "') is not available (weak dependency)");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
webpackContext.id = 5016;
module.exports = webpackContext;